"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import { ReactNode, RefObject, useCallback, useEffect, useLayoutEffect, useRef } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
function calculateDropdownLeft(buttonRight: number, dropdownWidth: number, offsetParentLeft: number): number {
  const referenceRight = buttonRight - offsetParentLeft;
  return Math.max(0, referenceRight - dropdownWidth);
}
export default function CommonDropdownItemsDefaultWrapper(t0) {
  const $ = _c(22);
  const {
    isOpen,
    setOpen,
    buttonRef,
    buttonPosition,
    dynamicPosition: t1,
    children
  } = t0;
  const dynamicPosition = t1 === undefined ? true : t1;
  const listRef = useRef(null);
  let t2;
  if ($[0] !== buttonRef || $[1] !== setOpen) {
    t2 = e => {
      if (buttonRef.current && e.target instanceof Node && buttonRef.current.contains(e.target)) {
        return;
      }
      setOpen(false);
    };
    $[0] = buttonRef;
    $[1] = setOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useClickAway(listRef, t2);
  let t3;
  if ($[3] !== setOpen) {
    t3 = () => setOpen(false);
    $[3] = setOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useKeyPressEvent("Escape", t3);
  const dropdownRef = useRef(null);
  const buttonRight = buttonPosition?.right ?? null;
  let t4;
  if ($[5] !== buttonRight || $[6] !== dynamicPosition || $[7] !== isOpen) {
    t4 = () => {
      if (!dynamicPosition) {
        return;
      }
      if (!isOpen) {
        return;
      }
      const el = dropdownRef.current;
      const width = listRef.current?.offsetWidth ?? el?.offsetWidth ?? 0;
      if (el && typeof buttonRight === "number") {
        const offsetParent = el.offsetParent;
        const offsetLeft = offsetParent instanceof HTMLElement ? offsetParent.getBoundingClientRect().left : 0;
        const left = calculateDropdownLeft(buttonRight, width, offsetLeft);
        el.style.left = `${left}px`;
      }
    };
    $[5] = buttonRight;
    $[6] = dynamicPosition;
    $[7] = isOpen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const position = t4;
  let t5;
  let t6;
  if ($[9] !== position) {
    t5 = () => {
      position();
    };
    t6 = [position];
    $[9] = position;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useLayoutEffect(t5, t6);
  let t7;
  let t8;
  if ($[12] !== dynamicPosition || $[13] !== isOpen || $[14] !== position) {
    t7 = () => {
      if (!dynamicPosition || !isOpen) {
        return;
      }
      const onResize = () => position();
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    };
    t8 = [dynamicPosition, isOpen, position];
    $[12] = dynamicPosition;
    $[13] = isOpen;
    $[14] = position;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  useEffect(t7, t8);
  let t9;
  if ($[17] !== children || $[18] !== isOpen) {
    t9 = isOpen && <motion.div ref={listRef} role="menu" tabIndex={-1} className="tw-mt-2 tw-w-72 tw-rounded-lg tw-bg-iron-900 tw-py-1 tw-shadow-lg tw-ring-1 tw-ring-white/10 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/20" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-max-h-80 tw-overflow-y-auto tw-overflow-x-hidden"><ul className="tw-flex tw-flex-col tw-gap-0.5 tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{children}</ul></div></motion.div>;
    $[17] = children;
    $[18] = isOpen;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="tw-absolute tw-z-50" ref={dropdownRef}><AnimatePresence mode="wait" initial={false}>{t9}</AnimatePresence></div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}